import { dynamicPageResponse } from './models';
import { createQuery } from '../../libs';
import { long_term_cashing } from '@/constants/cashing';

const url = 'dynamic-pages';

export const useGetDynamicPage = createQuery<dynamicPageResponse>(
  {
    method: 'get',
    url: `${url}/:type`,
  },
  {
    staleTime: long_term_cashing,
    keepPreviousData: false,
  }
);
